import { components, OptionProps, PlaceholderProps } from 'react-select';
import { CodeNameModel } from 'components/common/types';
import Chip, { Color, Size } from 'lib/Chip';
import { BaseSelectOptionProps } from './BaseSelect.types';
import BaseSelectOption from './BaseSelectOption';

export const MultiSelectOption = ({
  isSelected,
  innerRef,
  innerProps,
  children,
}: BaseSelectOptionProps & OptionProps<CodeNameModel>): React.ReactElement => (
  <BaseSelectOption isMultiple isSelected={isSelected} innerRef={innerRef} innerProps={innerProps}>
    {children}
  </BaseSelectOption>
);

export const createMultiSelectPlaceholder =
  (label: string, placeholder: string, chipDataTestId?: string) =>
  ({ children, ...props }: PlaceholderProps): React.ReactElement => {
    const selected = props.selectProps.value as CodeNameModel[] | null;
    const count = selected?.length ?? 0;

    return (
      // eslint-disable-next-line react/jsx-props-no-spreading
      <components.Placeholder {...props}>
        <div className="flex items-center flex-1 min-w-0 gap-1 pr-0.5">
          {count === 0 && <div className="ml-2 mr-auto body-base text-neutral-600">{placeholder}</div>}
          {count === 1 && (
            <div className="ml-2 mr-auto min-w-0 flex-1 body-base text-neutral-900 truncate" title={selected![0].name}>
              {selected![0].name}
            </div>
          )}
          {count > 1 && (
            <div className="mr-auto flex min-w-0 items-center">
              <div className="mr-2 truncate body-base text-neutral-600">{label}</div>
              <div className="shrink-0">
                <Chip label={`${count}`} color={Color.PRIMARY} size={Size.SMALL} dataTestId={chipDataTestId} />
              </div>
            </div>
          )}
        </div>
        <div className="h-0 overflow-hidden">{children}</div>
      </components.Placeholder>
    );
  };
